import React from 'react';
import { motion } from 'framer-motion';
import { Puzzle, Zap, Cloud } from 'lucide-react';
export function IntegrationSlide() {
  const majorIntegrationLogos = ['https://cdn.magicpatterns.com/uploads/35ePFuQrP3o48khxTWVME9/SET_Ventures_(3).png', 'https://cdn.magicpatterns.com/uploads/rVRqgc8M59fnqaX6F6QfY5/SET_Ventures_(2).png', 'https://cdn.magicpatterns.com/uploads/jppGGAss9xiH1zeiEghdML/SET_Ventures_(1).png', 'https://cdn.magicpatterns.com/uploads/mnadx61pW41g77hh7XTtUE/SET_Ventures_(5).png'];
  const chargerLogos = ['https://cdn.magicpatterns.com/uploads/xAdEArP8wvLNMGwssHS6Qm/SET_Ventures_(8).png', 'https://cdn.magicpatterns.com/uploads/bLmdGPMjtcHi6SMmrYS8hN/SET_Ventures_(7).png', 'https://cdn.magicpatterns.com/uploads/pqRuCs6hugRdcPhbUPsmTq/amina.png', 'https://cdn.magicpatterns.com/uploads/tUsDQc2qr375HLSoyAdxWC/SET_Ventures_(10).png', 'https://cdn.magicpatterns.com/uploads/vaoKnQmvCTKvY6z8EE2cTy/SET_Ventures_(9).png', 'https://cdn.magicpatterns.com/uploads/btxAkBu9Bc1ZPrZ55MYmDo/wallbox-logo.png'];
  const apiEndpoints = [{
    method: 'GET',
    path: '/chargers'
  }, {
    method: 'POST',
    path: '/sessions'
  }, {
    method: 'PUT',
    path: '/settings'
  }];
  return <div className="h-full w-full flex flex-col items-center justify-start md:justify-center px-4 md:px-8 bg-[#11166b] relative overflow-y-auto md:overflow-hidden py-16 md:py-0" data-id="element-60">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#00d8a8]/5 via-[#11166b] to-purple-950/20 pointer-events-none" data-id="element-61" />

      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center mb-8 md:mb-12 relative z-10 mt-4 md:mt-0" data-id="element-62">
        <div className="inline-flex items-center justify-center p-3 bg-[#00d8a8]/10 rounded-xl mb-4 md:mb-6" data-id="element-63">
          <Puzzle className="w-8 h-8 md:w-10 md:h-10 text-[#00d8a8]" data-id="element-64" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-65">
          Open Ecosystem
        </h2>
        <p className="text-base md:text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-66">
          Seamlessly integrate with your existing infrastructure and scale
          without constraints.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl w-full relative z-10 pb-24 md:pb-0" data-id="element-67">
        {/* Major Integrations with Logos */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-[#0d1155]/80 backdrop-blur-sm border border-[#1a2080] p-6 md:p-8 rounded-2xl flex flex-col" data-id="element-68">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-[#00d8a8]/10 rounded-xl flex items-center justify-center mb-3 md:mb-4" data-id="element-69">
            <Puzzle className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8]" data-id="element-70" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-71">
            Major Integrations
          </h3>
          <p className="text-sm md:text-base text-slate-300 mb-6" data-id="element-72">
            Pre-built integrations with major CPMS providers.
          </p>

          {/* Integration Logos */}
          <div className="" data-id="element-73">
            <div className="grid grid-cols-2 gap-3" data-id="element-74">
              {majorIntegrationLogos.map((logo, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.4 + idx * 0.1
            }} className="bg-white/95 rounded-lg p-3 flex items-center justify-center h-16" data-id="element-75">
                  <img src={logo} alt={`Integration partner ${idx + 1}`} className="max-w-full max-h-full object-contain" data-id="element-76" />
                </motion.div>)}
            </div>
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1.0
          }} className="text-center text-slate-400 text-sm mt-3" data-id="element-77">
              & more
            </motion.p>
          </div>
        </motion.div>

        {/* Universal Charger Support with Logos */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="bg-[#0d1155]/80 backdrop-blur-sm border border-[#1a2080] p-6 md:p-8 rounded-2xl flex flex-col" data-id="element-78">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-[#00d8a8]/10 rounded-xl flex items-center justify-center mb-3 md:mb-4" data-id="element-79">
            <Zap className="w-5 h-5 md:w-6 md:h-6 text-[#00d8a8]" data-id="element-80" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-81">
            Universal Charger Support
          </h3>
          <p className="text-sm md:text-base text-slate-300 mb-6" data-id="element-82">
            One interface for all charger brands. No vendor lock-in.
          </p>

          {/* Charger Brand Logos */}
          <div className="mt-auto" data-id="element-83">
            <div className="grid grid-cols-2 gap-3" data-id="element-84">
              {chargerLogos.map((logo, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.5 + idx * 0.1
            }} className="bg-white/95 rounded-lg p-3 flex items-center justify-center h-16" data-id="element-85">
                  <img src={logo} alt={`Charger brand ${idx + 1}`} className="max-w-full max-h-full object-contain" data-id="element-86" />
                </motion.div>)}
            </div>
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1.1
          }} className="text-center text-slate-400 text-sm mt-3" data-id="element-87">
              & more
            </motion.p>
          </div>
        </motion.div>

        {/* API-First with Visualization */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-[#0d1155]/80 backdrop-blur-sm border border-[#1a2080] p-6 md:p-8 rounded-2xl flex flex-col" data-id="element-88">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-purple-500/10 rounded-xl flex items-center justify-center mb-3 md:mb-4" data-id="element-89">
            <Cloud className="w-5 h-5 md:w-6 md:h-6 text-purple-400" data-id="element-90" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-91">
            API-First
          </h3>
          <p className="text-sm md:text-base text-slate-300 mb-6" data-id="element-92">
            Build custom integrations with our comprehensive REST API.
          </p>

          {/* API Visualization */}
          <div className="space-y-2" data-id="element-93">
            {apiEndpoints.map((endpoint, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.6 + idx * 0.15
          }} className="bg-[#11166b]/50 border border-[#1a2080] rounded-lg p-3 font-mono text-xs flex items-center gap-2" data-id="element-94">
                <span className="text-[#00d8a8] font-semibold" data-id="element-95">
                  {endpoint.method}
                </span>
                <span className="text-slate-400" data-id="element-96">/api/v1</span>
                <span className="text-slate-300" data-id="element-97">{endpoint.path}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>

      {/* Integration diagram abstract */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.6,
      duration: 0.8
    }} className="mt-8 md:mt-12 relative" data-id="element-98"></motion.div>
    </div>;
}